import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Type } from '@angular/core';
import { DropOffActionBaseComponent, ValidateBookingActionBaseComponent } from '@luggagehero/features/bookings';
import { SharedBookingService } from '@luggagehero/shared/services/bookings';
import { SharedOrderService } from '@luggagehero/shared/services/orders';
import { SharedShopsService } from '@luggagehero/shared/services/shops';
import { SharedStorageService } from '@luggagehero/shared/services/storage';
import { SharedUserService } from '@luggagehero/shared/services/users';

import { ValidateBookingActionComponent } from '../validate-booking-action/validate-booking-action.component';

@Component({
  selector: 'lh-drop-off-action',
  templateUrl: './drop-off-action.component.html',
  styleUrls: ['./drop-off-action.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DropOffActionComponent extends DropOffActionBaseComponent {
  constructor(
    orderService: SharedOrderService,
    userService: SharedUserService,
    bookingService: SharedBookingService,
    shopsService: SharedShopsService,
    storageService: SharedStorageService,
    cd: ChangeDetectorRef,
  ) {
    super(orderService, userService, bookingService, shopsService, storageService, cd);
  }

  protected get validateBookingActionComponentType(): Type<ValidateBookingActionBaseComponent> {
    return ValidateBookingActionComponent;
  }
}
